<template>
	<div class="contact__element contact__checkbox">
		<h3 v-if="content.title" class="checkbox__heading">{{ checkboxGroupTitle }}</h3>
		<div v-for="input in content.checkboxArray" class="checkbox__element">
			<input type="checkbox"
						 :id="`contact-${input.en.toLowerCase().replace(' ', '-')}`"
						 :name="input.en.toLowerCase()"
						 class="checkbox__input">
			<label :for="`contact-${input.en.toLowerCase().replace(' ', '-')}`"
						 class="checkbox__label">
				{{ locale === 'en' ? input.en : input.jp }}
			</label>
		</div>
	</div>
</template>

<script setup>
	import { useI18n, useLocalePath } from '#imports'
	import { computed } from 'vue'
	const { locale } = useI18n()
	const localePath = useLocalePath()
	const props = defineProps({
		content: Object
	})
	let checkboxGroupTitle
	if(props.content.title.en) {
		checkboxGroupTitle = locale.value === 'en' ? props.content.title.en  : props.content.title.jp
	}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.contact__checkbox {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	margin: 0 0 3rem 0;
	.checkbox__heading {
		margin: 0 0 1rem 0;
		width: 100%;
	}
	.checkbox__element {
		align-items: center;
		display: flex;
		margin: 0.5rem 2rem 0.5rem 0;
		.checkbox__input {
			outline: 0.05rem solid v.$lightGrey;
			display: inline-block;
			height: 2rem;
			margin: 0 0.5rem 0 0;
			width: 2rem;
			-moz-appearance:none;
			-webkit-appearance:none;
			-o-appearance:none;
			&:checked {
				&::before {
					color: v.$white;
					 content: '\02714';
					display: block;
					font-size: v.$font-size-lg;
					padding: 0.1rem;
					height: 100%;
					text-align: center;
					width: 100%;
				}
				background-color: v.$teal;
			}
			&:focus {
				outline: 0.05rem solid v.$teal;
				box-shadow: 0 0 7px -3px v.$teal;
				transition: 0.3s;
			}
		}
		.checkbox__label {
			position: relative;
		}
	}
}
</style>
